import { BACKEND_URL } from "@/lib/api";

export async function streamAi(path, body, onDelta, signal) {
  const res = await fetch(`${BACKEND_URL}/api/ai/${path}`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body || {}), signal });
  if (!res.ok) {
    let detail = "The writing assistant is unavailable right now.";
    try { const j = await res.json(); detail = typeof j.detail === "string" ? j.detail : j.detail?.message || detail; } catch { /* keep default */ }
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let text = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop();
    for (const ev of events) {
      const line = ev.split("\n").find((l) => l.startsWith("data: "));
      if (!line) continue;
      const data = JSON.parse(line.slice(6));
      if (data.error) throw new Error(data.error);
      if (data.delta) { text += data.delta; onDelta?.(text); }
    }
  }
  return text;
}
